// App.js
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";

import Layout from "./pages/Layout";
import { Home } from "./pages/Home.jsx";
import { AboutUs } from "./pages/AboutUs.jsx";
import { Literary } from "./pages/Literary.jsx";
import { Authors } from "./pages/Authors.jsx";
import { ContactUs } from "./pages/ContactUs.jsx";
import { PrivacyPolicy } from "./pages/PrivacyPolicy.jsx";
import { CookiePolicy } from "./pages/CookiePolicy.jsx";
import { TermsOfUse } from "./pages/TermsOfUse.jsx";
import { Excerpts } from "./pages/Excerpts.jsx";
import { AuthorInfo } from "./components/OtherPages/AuthorInfo.jsx";
import { BookSummary } from "./components/OtherPages/BookSummary.jsx";
import { ExcerptsSummary } from "./components/OtherPages/ExcerptsSummary.jsx";

import CursorLine from "./Cursor/CursorLine.jsx";
import CookieConsent from "react-cookie-consent";

// GA helper
import { initGA, logPageView } from "./utils/ga";

// --- GA Listener Component ---
function GAListener({ children }) {
  const location = useLocation();

  useEffect(() => {
    initGA(); // initialize GA once
  }, []);

  useEffect(() => {
    logPageView(location.pathname + location.search);
  }, [location]);

  return children; // <-- Important
}

// --- Main App ---
function App() {
  return (
    <>
      <CookieConsent
        location="bottom"
        buttonText="I understand"
        style={{ background: "#2B373B" }}
        buttonStyle={{
          background: "#000000",
          color: "white",
          fontSize: "12px",
        }}
        expires={150}
      >
        This website uses cookies to enhance the user experience.
      </CookieConsent>

      <BrowserRouter>
        <GAListener>
          <CursorLine />
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="about-us" element={<AboutUs />} />
              <Route path="literary" element={<Literary />} />
              <Route path="excerpts" element={<Excerpts />} />
              <Route path="authors" element={<Authors />} />
              <Route path="contact-us" element={<ContactUs />} />
              <Route path="privacy-policy" element={<PrivacyPolicy />} />
              <Route path="cookie-policy" element={<CookiePolicy />} />
              <Route path="terms-of-use" element={<TermsOfUse />} />

              {/* Nested dynamic routes */}
              <Route path="author/:id" element={<AuthorInfo />} />
              <Route path="literary/:id" element={<BookSummary />} />
              <Route path="excerpts/:id" element={<ExcerptsSummary />} />
            </Route>
          </Routes>
        </GAListener>
      </BrowserRouter>
    </>
  );
}

export default App;
